<template>
    <div class="cc-tabs">
        <div class="cc-tabs-container" :style="{ backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none', minWidth: '150px' }">
            <div class="cc-tabs-alltabs" :style="alltabs_style">
                <div class="q-pa-sm cc-tab-item-group" :class="dark ? 'cc-theme-dark' : 'cc-theme-light'">
                    <div v-for="(item, index) in items" :key="item.id" :class="getTabItemClass(item)">
                        <QCard
                            v-if="!item.separator"
                            flat
                            class="d-flex align-center q-mb-sm cc-tab-item"
                            :class="{ 'cc-selected-item': selected_item === index }"
                            style="min-height: 40px; height: 40px;"
                            @click="selectTab(item, index)">
                            <div :class="getTabITemContentClass(item)">
                                <slot name="label" :item="item">
                                    <span v-if="item.title">{{ item.title }}</span>
                                    <QIcon v-if="item.icon" :name="normalizeIcon(item.icon)" size="sm" class="q-ml-sm" />
                                </slot>
                            </div>
                        </QCard>
                        <div v-else></div>
                    </div>
                </div>
            </div>
            <slot>
                <div class="cc-tabs-actions">
                    <QBtn class="cc-tabs-actions__button c-SentenceCaseButton" size="12px" color="primary" no-caps>{{ addlabel || 'Add' }}</QBtn>
                    <QBtn class="cc-tabs-actions__button c-SentenceCaseButton" size="12px" color="negative" no-caps>{{ removelabel || 'Remove' }}</QBtn>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
    import { QCard, QIcon, QBtn } from 'quasar';
    import utils from '../../../Shared/utils.jsx';

    export default {
        name: 'c-vertical-Tabs',
        components: { QCard, QIcon, QBtn },
        emits: ['menu', 'change'],
        data: function () {
            return {
                selected_item: null,
            }
        },
        props: {
            default_selected: null,
            value: null,
            items: null,
            addlabel: null,
            removelabel: null,
            backgroundImage: null,
            dark: true,
            maxHeight: null,
        },
        created() {
            //if (this.default_selected !== null)
            //    this.selected_item = this.items.findIndex(i => i.id == this.default_selected);
            if (this.value !== null && this.value !== undefined) {
                this.selected_item = this.value;
            }
        },
        watch: {
            value: function (newvalue) {
                this.selected_item = newvalue;
            },
        },
        computed: {
            activeClass: function () {
                return this.dark ? 'cc-tab-item_active_dark' : 'cc-tab-item_active_light';
            },
            alltabs_style: function () {
                if (this.maxHeight !== null)
                    return { maxHeight: this.maxHeight + 'px' };
                else
                    return null;
            }
        },
        methods: {
            getTabItemClass(item) {
                const c = {
                    'cc-tabs-items': true,
                    'cc-tabs-items__separator': !!item.separator,
                };

                if (this.dark)
                    c['cc-theme-dark'] = true;
                else
                    c['cc-theme-light'] = true;

                return c;
            },
            getTabITemContentClass(item) {
                return {
                    'cc-tab-item__content': !item.menu,
                    'cc-tab-item__button': !!item.menu,
                };
            },
            normalizeIcon(icon) {
                if (!icon || typeof icon !== 'string') return icon;
                return icon.replace(/^\s*mdi\s+/, '').trim() || icon;
            },
            selectTab(item, index) {
                if (item.menu) {
                    this.$emit('menu', item);
                }
                else {
                    this.selected_item = index;
                    this.$emit('change', this.selected_item);
                }
            }
        }
    }
</script>

<style scoped>
    .cc-tab-item-group {
        padding-right: unset !important;
    }

    .cc-tabs {
        display: flex;
    }

    .cc-tabs-container {
        display: flex;
        flex-direction: column;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .cc-tabs-alltabs {
        /*max-height: 300px;*/
        display: flex;
        flex-grow: 1;
        overflow-y: auto;
        /* Avoid phantom horizontal scrollbar when vertical overflow is present (CCDEV-16497). */
        overflow-x: hidden;
    }

    .cc-tab-item-group {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }

    .cc-tabs-items__separator {
        flex-grow: 1;
    }

    .cc-tabs-actions {
        display: flex;
        justify-content: center;
    }

    .cc-tabs-actions__button {
        flex: 1 1 0;
    }

    .cc-tabs-group {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        min-width: 250px;
    }

    .cc-tabs-group__items {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        padding: 5px;
    }

    .cc-tabs-items {
        margin: 0;
    }

    .cc-theme-dark {
        color: silver;
    }

    .cc-theme-light {
        color: black;
    }

    /*color: silver;*/

    .cc-tab-item {
        padding: 5px;
        border-radius: 8px 0 0 8px;
        cursor: pointer;
        background-color: transparent;
    }

    .cc-tab-item:hover:not(.cc-selected-item) {
        background-color: var(--v-activeBackground-base);
    }

    .cc-theme-dark .cc-tab-item:hover:not(.cc-selected-item) {
        background-color: rgba(255, 255, 255, 0.08);
    }

    .cc-tab-item.cc-selected-item {
        color: var(--q-primary);
        background-color: var(--v-activeBackground-base);
    }

    .cc-tab-item.cc-selected-item:hover {
        background-color: var(--v-activeBackground-base);
    }

    .cc-tab-item_active_dark {
        color: white;
        background-color: var(--v-activeBackground-base);
        border: 1px solid silver;
    }

    .cc-tab-item_active_light {
        color: var(--q-primary);
        background-color: var(--v-activeBackground-base);
        border: 1px solid silver;
    }

    .cc-tab-item__content {
        width: 100%;
        display: flex;
        padding-left: 5px;
        padding-right: 5px;
        justify-content: space-between;
        align-items: center;
        white-space: nowrap;
    }

    .cc-tab-item__button {
        width: 100%;
        display: flex;
        padding-left: 0;
        padding-right: 0;
        justify-content: space-between;
        align-items: center; 
        white-space: nowrap;
    }

</style>